var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProPlanV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.689911,
    width: 70,
    height: 70,
    rx: 12,
    fill: "#FEEFD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9374 23.75V26.25C46.9374 31.0825 43.0199 35 38.1874 35H36.9374V36.25H43.1874V45C43.1874 46.3808 42.0682 47.5 40.6874 47.5H30.6875C29.3068 47.5 28.1875 46.3808 28.1875 45V36.25H34.4374V32.5C34.4374 27.6675 38.355 23.75 43.1874 23.75H46.9374ZM27.5625 22.5C30.7232 22.5 33.5187 24.0642 35.2169 26.4608C33.9432 28.1386 33.1875 30.231 33.1875 32.5V33.75H32.5625C27.3848 33.75 23.1875 29.5527 23.1875 24.375V22.5H27.5625Z",
    fill: "#F9AD19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProPlanV2);
export default __webpack_public_path__ + "static/media/pro_plan_v2.7a3df1ff3c10943b36ff1976997bde61.svg";
export { ForwardRef as ReactComponent };